<template>
  <v-dialog persistent v-model="dialog" :fullscreen="!isLoading">
    <v-card v-if="isLoading == false">
      <v-toolbar class="elevation-0" color="black" dark
        ><v-toolbar-title>{{
          editedIndex == -1 ? "Create Campaign Review" : "Edit Campaign Review"
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('onClosed')"
          ><v-icon>close</v-icon></v-btn
        ></v-toolbar
      >
      <v-card-text style="height: 82vh; overflow: auto">
        <v-form ref="formCampaign">
          <v-layout
            wrap
            style="border: 1.5px solid #c9c9c9; border-radius: 10px"
            class="px-3"
          >
            <v-flex xs12 class="pa-1"
              ><v-radio-group
                row
                v-model="isSelectProvince"
                @change="form.campaign_review_province = []"
                ><v-radio
                  color="black"
                  label="All province"
                  :value="false"
                ></v-radio>
                <v-radio
                  color="black"
                  label="Some province"
                  :value="true"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 class="px-1" v-if="isSelectProvince == true"
              ><v-autocomplete
                class="pa-0"
                multiple
                chip
                :items="provinceData"
                item-text="province_name_th"
                item-value="province_id"
                label="Select Province"
                :rules="[(v) => v.length > 0 || 'required']"
                v-model="form.campaign_review_province"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            style="border: 1.5px solid #c9c9c9; border-radius: 10px"
            class="px-3 mt-3"
          >
            <v-flex xs12 sm6 class="pa-1">
              <v-text-field
                v-model="form.campaign_review_name_th"
                label="Name TH"
                counter="100"
                :rules="[
                  (v) => !!v || 'Required',
                  (v) => v.length <= 100 || 'Character must less than 100',
                ]"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-text-field
                v-model="form.campaign_review_name_en"
                label="Name EN"
                counter="100"
                :rules="[
                  (v) => !!v || 'Required',
                  (v) => v.length <= 100 || 'Character must less than 100',
                ]"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-textarea
                label="Description TH"
                v-model="form.campaign_review_description_th"
              ></v-textarea
            ></v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-textarea
                label="Description EN"
                v-model="form.campaign_review_description_en"
              ></v-textarea
            ></v-flex>
          </v-layout>
          <v-layout
            wrap
            style="border: 1.5px solid #c9c9c9; border-radius: 10px"
            class="px-3 mt-3"
          >
            <v-flex xs12 sm4 class="pa-1">
              <v-text-field
                type="number"
                v-model="form.campaign_review_reward_life_span.amount"
                :label="`Time Expiration`"
                :rules="[(v) => (!!v && v != '0') || 'Required or more than 0']"
              ></v-text-field
            ></v-flex>

            <v-flex xs12 sm2 class="pa-1">
              <v-select
                v-model="form.campaign_review_reward_life_span.unit"
                :items="['day', 'hour', 'minute']"
              ></v-select
            ></v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-text-field
                type="number"
                v-model="form.campaign_review_total_amount"
                :label="`Total Redeem`"
                :rules="[(v) => (!!v && v != '0') || 'Required or more than 0']"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-menu
                ref="menuDateStart"
                v-model="menuDateStart"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="form.campaign_review_start_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.campaign_review_start_date"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :rules="[
                      (v) => !!v || 'Required',
                      moment(form.campaign_review_start_date) <
                        moment(form.campaign_review_end_date) ||
                        'invalid date start - end',
                    ]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="black"
                  v-model="form.campaign_review_start_date"
                  year-icon="mdi-calendar-blank"
                  prev-icon="mdi-skip-previous"
                  next-icon="mdi-skip-next"
                  @change="
                    $refs.menuDateStart.save(form.campaign_review_start_date)
                  "
                ></v-date-picker> </v-menu
            ></v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-menu
                ref="menuDateEnd"
                v-model="menuDateEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="form.campaign_review_end_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.campaign_review_end_date"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :rules="[
                      (v) => !!v || 'Required',
                      moment(form.campaign_review_start_date) <
                        moment(form.campaign_review_end_date) ||
                        'invalid date start - end',
                    ]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="black"
                  v-model="form.campaign_review_end_date"
                  year-icon="mdi-calendar-blank"
                  prev-icon="mdi-skip-previous"
                  next-icon="mdi-skip-next"
                  @change="
                    $refs.menuDateEnd.save(form.campaign_review_end_date)
                  "
                ></v-date-picker> </v-menu
            ></v-flex>
          </v-layout>
          <v-tabs
            v-model="model"
            centered
            color="#141414"
            dark
            class="mt-3"
            style="border-radius: 10px"
          >
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab
              v-for="(info, index) in form.campaign_review_level"
              :key="'#tab-' + index"
              :href="'#tab-' + index"
            >
              {{ info.rank_name }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="model" class="mt-2">
            <v-tab-item
              v-for="(info, index) in form.campaign_review_level"
              :key="'tab-' + index"
              :value="'tab-' + index"
            >
              <v-card flat color="#f9f9f9" style="border-radius: 10px">
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 sm11 class="pa-1">
                      <v-text-field
                        v-model="info.rank_review_normal_amount"
                        type="number"
                        label="ส่วนลดรีวิวแบบไม่เขียนรีวิวไม่ใส่รูปภาพ"
                        :rules="[(v) => v == '0' || !!v || 'Required']"
                      ></v-text-field
                    ></v-flex>
                    <v-flex xs12 sm1 class="pa-1">
                      <v-select
                        v-model="info.rank_review_normal_unit"
                        label="ประเภทส่วนลดรีวิวแบบไม่เขียนรีวิวไม่ใส่รูปภาพ"
                        :items="[
                          { name: 'บาท', value: 'baht' },
                          { name: '%', value: 'percentage' },
                        ]"
                        item-value="value"
                        item-text="name"
                      ></v-select
                    ></v-flex>

                    <v-flex xs12 sm11 class="pa-1">
                      <v-text-field
                        v-model="info.rank_review_with_image_amount"
                        type="number"
                        label="ส่วนลดรีวิวแบบไม่เขียนรีวิวใส่รูปภาพ"
                        :rules="[(v) => v == '0' || !!v || 'Required']"
                      ></v-text-field
                    ></v-flex>
                    <v-flex xs12 sm1 class="pa-1">
                      <v-select
                        v-model="info.rank_review_with_image_unit"
                        label="ประเภทส่วนลดรีวิวแบบไม่เขียนรีวิวใส่รูปภาพ"
                        :items="[
                          { name: 'บาท', value: 'baht' },
                          { name: '%', value: 'percentage' },
                        ]"
                        item-value="value"
                        item-text="name"
                      ></v-select
                    ></v-flex>
                    <v-flex xs12 sm11 class="pa-1">
                      <v-text-field
                        v-model="info.rank_review_normal_with_text_amount"
                        type="number"
                        label="ส่วนลดรีวิวแบบเขียนรีวิวไม่ใส่รูปภาพ"
                        :rules="[(v) => v == '0' || !!v || 'Required']"
                      ></v-text-field
                    ></v-flex>
                    <v-flex xs12 sm1 class="pa-1">
                      <v-select
                        v-model="info.rank_review_normal_with_text_unit"
                        label="ประเภทส่วนลดรีวิวแบบเขียนรีวิวไม่ใส่รูปภาพ"
                        :items="[
                          { name: 'บาท', value: 'baht' },
                          { name: '%', value: 'percentage' },
                        ]"
                        item-value="value"
                        item-text="name"
                      ></v-select
                    ></v-flex>
                    <v-flex xs12 sm11 class="pa-1">
                      <v-text-field
                        v-model="info.rank_review_with_image_with_text_amount"
                        type="number"
                        label="ส่วนลดรีวิวแบบเขียนรีวิวและใส่รูปภาพ"
                        :rules="[(v) => v == '0' || !!v || 'Required']"
                      ></v-text-field
                    ></v-flex>
                    <v-flex xs12 sm1 class="pa-1">
                      <v-select
                        v-model="info.rank_review_with_image_with_text_unit"
                        label="ประเภทส่วนลดรีวิวแบบเขียนรีวิวและใส่รูปภาพ"
                        :items="[
                          { name: 'บาท', value: 'baht' },
                          { name: '%', value: 'percentage' },
                        ]"
                        item-value="value"
                        item-text="name"
                      ></v-select
                    ></v-flex> </v-layout
                ></v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-card flat style="border: 1.5px solid #c9c9c9; border-radius: 10px" class="mt-2 pa-1">
            <v-layout wrap>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                  v-model="form.campaign_reward_per_user"
                  type="number"
                  label="จำนวนส่วนลดต่อบัญชี"
                  :rules="[(v) => v == '0' || !!v || 'Required']"
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <v-text-field
                append-icon="mdi-currency-thb"
                type="number"
                  v-model="form.campaign_review_maximum_discount"
                  label="ส่วนลดสูงสุด"
                  :rules="[(v) => (v > '0') || 'more than 0']"
                ></v-text-field
              ></v-flex>
            </v-layout>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3" style="display: flex; align-items: center">
        <v-spacer></v-spacer> <v-btn color="red" flat>Clear</v-btn>
        <v-btn
          color="primary"
          style="border-radius: 10px; color: black"
          :loading="isCreating"
          @click="submit()"
          >Save</v-btn
        >
      </v-card-actions></v-card
    >
    <v-card v-else color="primary" dark>
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text> </v-card
  ></v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["dialog", "editedIndex", "selectedItem"],
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  data() {
    return {
      model: "tab-0",
      form: {
        campaign_review_name_th: "",
        campaign_review_name_en: "",
        campaign_review_condition_detail_list: [],
        campaign_review_level: [],
        campaign_review_promotion_condition: [],
        campaign_review_reward_life_span: {},
        campaign_review_total_amount: null,
        campaign_review_count: "",
        campaign_review_max: "",
      },
      menuDateStart: false,
      menuDateEnd: false,
      isCreating: false,
      isSelectProvince: false,
      isLoading: false,
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        if (this.editedIndex == -1) {
          this.resetForm();
        } else {
          this.resetForm();
          this.isLoading = true;
          let result = await this.fetchCampaignReviewBenefitById(
            this.selectedItem.campaign_review_id
          );
          // console.log(result)
          result.campaign_review_reward_life_span = {
            amount: result.campaign_review_reward_life_span,
            unit: "minute",
          };

          if (result.campaign_review_province.length > 0) {
            this.isSelectProvince = true;
          } else {
            this.isSelectProvince = false;
          }

          if (result == false) return;
          Object.assign(this.form, result);
          this.isLoading = false;
          this.form.campaign_reward_per_user=result.campaign_reward_per_user
          this.form.campaign_review_maximum_discount=result.campaign_review_maximum_discount
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchCampaignReviewBenefitById:
        "fetchDineIn/fetchCampaignReviewBenefitById",
    }),
    resetForm() {
      this.form = {
        campaign_review_reward_life_span: {
          amount: 0,
          unit: "day",
        },
        campaign_review_province: [],
        campaign_review_name_th: "Test",
        campaign_review_name_en: "Test",
        campaign_review_description_th: "Test",
        campaign_review_description_en: "Test",
        campaign_review_highlight_th: "Test",
        campaign_review_highlight_en: "Test",
        campaign_review_condition_detail_list: [],
        campaign_review_level: [
          {
            rank_id: 1,
            rank_name: "standard",
            rank_review_normal_amount: 0,
            rank_review_normal_unit: "baht",
            rank_review_normal_with_text_amount: 0,
            rank_review_normal_with_text_unit: "baht",
            rank_review_with_image_amount: 0,
            rank_review_with_image_unit: "percentage",
            rank_review_with_image_with_text_amount: 0,
            rank_review_with_image_with_text_unit: "baht",
          },
          {
            rank_id: 2,
            rank_name: "silver",
            rank_review_normal_amount: 0,
            rank_review_normal_unit: "baht",
            rank_review_normal_with_text_amount: 0,
            rank_review_normal_with_text_unit: "baht",
            rank_review_with_image_amount: 0,
            rank_review_with_image_unit: "percentage",
            rank_review_with_image_with_text_amount: 0,
            rank_review_with_image_with_text_unit: "baht",
          },
          {
            rank_id: 3,
            rank_name: "gold",
            rank_review_normal_amount: 0,
            rank_review_normal_unit: "baht",
            rank_review_normal_with_text_amount: 0,
            rank_review_normal_with_text_unit: "baht",
            rank_review_with_image_amount: 0,
            rank_review_with_image_unit: "percentage",
            rank_review_with_image_with_text_amount: 0,
            rank_review_with_image_with_text_unit: "baht",
          },
          {
            rank_id: 4,
            rank_name: "platinum",
            rank_review_normal_amount: 0,
            rank_review_normal_unit: "baht",
            rank_review_normal_with_text_amount: 0,
            rank_review_normal_with_text_unit: "baht",
            rank_review_with_image_amount: 0,
            rank_review_with_image_unit: "percentage",
            rank_review_with_image_with_text_amount: 0,
            rank_review_with_image_with_text_unit: "baht",
          },
          {
            rank_id: 5,
            rank_name: "vip",
            rank_review_normal_amount: 0,
            rank_review_normal_unit: "baht",
            rank_review_normal_with_text_amount: 0,
            rank_review_normal_with_text_unit: "baht",
            rank_review_with_image_amount: 0,
            rank_review_with_image_unit: "percentage",
            rank_review_with_image_with_text_amount: 0,
            rank_review_with_image_with_text_unit: "baht",
          },
        ],
        // campaign_review_image: "",
        campaign_review_start_date: "2023-06-20",
        campaign_review_end_date: "2023-06-30",
        campaign_review_promotion_condition: [],
        campaign_review_total_amount: 1,
        campaign_reward_per_user: "",
        campaign_review_maximum_discount: "",
      };
      this.isSelectProvince = false;
      this.campaign_reward_per_user="";
      this.campaign_review_maximum_discount="";
      this.$refs.formCampaign.resetValidation();
    },
    async submit() {
      if (!this.$refs.formCampaign.validate()) return;
      let _this = this;
      this.isCreating = true;
      this.$emit("onSaved", {
        form: this.form,
        done() {
          _this.isCreating = false;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
